import * as React from 'react';
import { Translate, I18n } from 'react-redux-i18n';

import Popup from '../../../Popup';
import { PopupBody, Input, InputLabel, Error } from '../../styles';
import ValidationUtils from '../../../../utils/validation';

interface EmailIntegrationPopupProps {
	isDisplayed: boolean;
	onCancel: () => void;
	onConfirm: (email: string) => void;
	email: string;
}

const EmailIntegrationPopup = ({
	isDisplayed,
	onCancel,
	onConfirm,
	email: initialEmail,
}: EmailIntegrationPopupProps) => {
	const [email, setEmail] = React.useState(initialEmail);

	const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setEmail(e.target.value);
	};

	const isError = (): boolean => !ValidationUtils.isValidEmail(email);

	React.useEffect(() => {
		if (initialEmail !== email) {
			setEmail(initialEmail);
		}
	}, [initialEmail, isDisplayed]);

	return (
		<Popup
			isDisplayed={isDisplayed}
			label={I18n.t('messages.email_integration')}
			onCancel={onCancel}
			onConfirm={() => onConfirm(email)}
			isConfirmDisabled={isError()}
		>
			<PopupBody>
				<InputLabel>
					{isError()
						? <Error value="error.invalid_email_address" />
						: <Translate value="messages.email" />
					}
					<Input
						type="email"
						name="email"
						ref={(ref) => {
							if (ref) {
								ref.setAttribute('autocorrect', 'none');
								ref.setAttribute('autocapitalize', 'off');
								ref.setAttribute('spellcheck', 'false');
							}
						}}
						value={email}
						isError={isError()}
						onChange={handleInputChange}
					/>
				</InputLabel>
			</PopupBody>
		</Popup>
	);
};

export default EmailIntegrationPopup;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ProfilePage/EmailIntegration/EmailIntegrationPopup/index.tsx